import { TFunction } from 'i18next';
import { Services } from 'src/js/model/services';
import { port } from 'src/js/validator/validator';
import * as yup from 'yup';

export interface ServicesViewModel extends Services {}

/*
 * Yup validation schema
 */
export const servicesValidationSchema = (t: TFunction) =>
  yup.object<ServicesViewModel>().shape({
    passthroughPort: port(t).required(t('validation.required')),
  });
